import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import RentTermsMobile from './rentTermsMobile';
import RupeePinkIcon from 'assets/images/rupee-icon-black.png';
import { PdfButton } from 'components/atoms/pdfButton';
import './styles.scss';

const RentTerms = props => {
  const { isMobile, height } = useViewport();
  const { banner, setIsGetInTouchModalOpen, pdfUrl } = props.data;
  if (!banner) {
    return null;
  }

  return (
    <div className={'main-container'} style={{ height }} id={'rent-terms'}>
      {!isMobile ? (
        <Row className={'row-main'}>
          <Col xs={{ span: 11 }} md={{ span: 4, offset: 0 }} className="column">
            <HTMLView
              tagName={'h3'}
              className={'short-title'}
              html={'Listing Details'}
            />
            <HTMLView
              tagName={'h1'}
              className={'long-title'}
              html={'Rental Terms'}
            />
            <Row className={'sec-row'}>
              <Col md={4}>
                <HTMLView
                  tagName={'h4'}
                  className={'title'}
                  html={'Rental Price'}
                />
                <img
                  src={RupeePinkIcon}
                  alt="Rupees"
                  className={'currency-icon'}
                />
                <HTMLView
                  tagName={'h4'}
                  className={'title-description'}
                  html={banner.rental_price + 'per month'}
                />
              </Col>
              <Col md={8}>
                <HTMLView tagName={'h4'} className={'title'} html={'Deposit'} />
                <img
                  src={RupeePinkIcon}
                  alt="Rupees"
                  className={'currency-icon-sec'}
                />
                <HTMLView
                  tagName={'h4'}
                  className={'title-description'}
                  html={banner.deposit}
                />
              </Col>
              <Col md={4} style={{ marginTop: '4%' }}>
                <HTMLView
                  tagName={'h4'}
                  className={'title'}
                  html={'Max Rent Duration'}
                />
                <HTMLView
                  tagName={'h4'}
                  className={'title-description'}
                  html={banner.max_rent_duration}
                />
              </Col>
              <Col md={8} style={{ marginTop: '4%' }}>
                <HTMLView
                  tagName={'h4'}
                  className={'title'}
                  html={'Availability'}
                />
                <HTMLView
                  tagName={'h4'}
                  className={'title-description'}
                  html={banner.availability}
                />
              </Col>
              <Col md={4} style={{ marginTop: '4%' }}>
                <HTMLView
                  tagName={'h4'}
                  className={'title'}
                  html={'Currently'}
                />
                <HTMLView
                  tagName={'h4'}
                  className={'title-description'}
                  html={banner.currently}
                />
              </Col>
              <Col md={8} style={{ marginTop: '4%' }}>
                <HTMLView
                  tagName={'h4'}
                  className={'title'}
                  html={'Annual Rent Increase'}
                />
                <HTMLView
                  tagName={'h4'}
                  className={'title-description'}
                  html={banner.annual_rent_increase}
                />
              </Col>
            </Row>
            {pdfUrl && (
              <CallToAction
                text={'Download Brochure'}
                className={'explore-button'}
                mode={'dark'}
                onClick={() => window.open(pdfUrl, '_blank')}
              />
            )}
            <CallToAction
              text={'Book Now'}
              className={'explore'}
              mode={'dark'}
              onClick={() => setIsGetInTouchModalOpen(true)}
            />
          </Col>
          <Col
            xs={{ span: 11 }}
            md={{ span: 8, offset: 0 }}
            className={'second-column'}
          >
            <img
              src={banner.rental_image}
              alt="image"
              className={'main-image'}
            />
          </Col>
        </Row>
      ) : (
        <RentTermsMobile
          data={banner}
          setIsGetInTouchModalOpen={setIsGetInTouchModalOpen}
          pdfUrl={pdfUrl}
        />
      )}
    </div>
  );
};
export default RentTerms;
